(() => {
  if (window.AscProductCards) {
    window.AscProductCards.scan(document);
    return;
  }

  const initializeGallery = (gallery) => {
    if (gallery.dataset.mobileGalleryReady === 'true') return;

    const track = gallery.querySelector('[data-mobile-card-gallery-track]');
    const slides = Array.from(gallery.querySelectorAll('[data-mobile-card-slide]'));
    const card = gallery.closest('.asc-catalog-card');
    const scrollbar = card?.querySelector('[data-mobile-card-scrollbar]');
    const scrollbarThumb = scrollbar?.querySelector('[data-mobile-card-scrollbar-thumb]');
    if (!track || !slides.length) return;

    gallery.dataset.mobileGalleryReady = 'true';
    let activeIndex = 0;
    let scrollFrame = null;
    let pointerStartX = 0;
    let blockNextLink = false;

    const syncGallery = () => {
      scrollFrame = null;
      const slideWidth = track.clientWidth;
      if (!slideWidth) return;
      activeIndex = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / slideWidth)));

      if (scrollbar && scrollbarThumb) {
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        const maxThumbOffset = Math.max(0, scrollbar.clientWidth - scrollbarThumb.offsetWidth);
        const progress = maxScroll > 0 ? Math.min(1, Math.max(0, track.scrollLeft / maxScroll)) : 0;
        scrollbarThumb.style.transform = `translate3d(${progress * maxThumbOffset}px, 0, 0)`;
      }
    };

    track.addEventListener('scroll', () => {
      if (scrollFrame) cancelAnimationFrame(scrollFrame);
      scrollFrame = requestAnimationFrame(syncGallery);
    }, { passive: true });

    track.addEventListener('pointerdown', (event) => {
      pointerStartX = event.clientX;
      blockNextLink = false;
    }, { passive: true });

    track.addEventListener('pointermove', (event) => {
      if (Math.abs(event.clientX - pointerStartX) > 7) blockNextLink = true;
    }, { passive: true });

    track.addEventListener('click', (event) => {
      if (!blockNextLink) return;
      event.preventDefault();
      event.stopPropagation();
      blockNextLink = false;
    }, true);

    if ('ResizeObserver' in window) {
      const galleryObserver = new ResizeObserver(() => {
        if (!track.clientWidth) return;
        track.scrollLeft = activeIndex * track.clientWidth;
        syncGallery();
      });
      galleryObserver.observe(track);
    }

    syncGallery();
  };

  const scan = (root) => {
    if (root.matches?.('[data-mobile-card-gallery]')) initializeGallery(root);
    root.querySelectorAll?.('[data-mobile-card-gallery]').forEach(initializeGallery);
  };

  window.AscProductCards = { scan };
  scan(document);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) scan(node);
      });
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
